'use client';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { Fragment } from 'react';
export const Banner = props => {
  const { isMobile } = useIsMobile();
  const { url, classes, title, text, fileType = 'jpg' } = props;
  return (
    <Fragment>
      <div className='relative mb-[0] lg_mb-[60px]'>
        {/* /discount/medical-banner-m.webp */}
        <Image
          src={isMobile ? `${url}-m.${fileType}` : `${url}.${fileType}`}
          alt='affiliate-program'
          width={isMobile ? 750 : 3840}
          height={isMobile ? 400 : 740}
          className=' h-auto min-h-[200px] w-full object-cover lg_min-h-[370px]'
        />

        <div className={cn('absolute left-0 top-0 hidden h-full w-full lg_block', classes?.contentBox)}>
          <div className='container mx-auto flex h-full flex-col items-start justify-center'>
            <div
              className={cn(
                'mb-[40px] font-teko-medium text-[40px] font-medium uppercase leading-[40px] text-white',
                classes?.titlePc,
              )}
              style={{ textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)' }}
            >
              {title}
            </div>
            <p
              className={cn(
                'text-left font-roboto-medium text-[18px] font-medium leading-[21px] text-white',
                classes?.textPc,
              )}
              style={{ textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)' }}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </div>
        </div>
      </div>
      <div className={cn('mb-[40px] w-full bg-[#F9F9F9] px-[12px] py-[24px] lg_mb-[0] lg_hidden', classes?.mobileBox)}>
        <h1
          className={cn(
            ' mb-[10px] font-teko-medium text-[30px] font-medium uppercase leading-[28px] text-black',
            classes?.titleMobile,
          )}
        >
          {title}
        </h1>
        <p
          className={cn('font-roboto-regular text-[16px] font-medium leading-[24px] text-black', classes?.textMobile)}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </Fragment>
  );
};
